import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';

const ErrorAlert = ({message}) => {
  // the alert is displayed by default
  const [alert, setAlert] = useState(true);
      
  useEffect(() => {
    // when the component is mounted, the alert is displayed for 3 seconds
    setTimeout(() => {
      setAlert(false);
    }, 5000);
  }, []);     
    
  return alert &&
  <Alert severity="error">{message}</Alert>
}

export default ErrorAlert;